module.exports = __webpack_public_path__ + "static/img/banner1.1eab686.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner1.png
// module id = rhUP
// module chunks = 1